import findId from "../../../../static/img/bidra-dokumentasjon/component-overview-find-id.png";
import * as React from 'react';
export default {
  findId,
  React
};